import { createSlice } from '@reduxjs/toolkit';
import { AlarmDetailFromNotificationMessageModel } from '../../@types/alarm-detail';
import { dispatch } from '../store';
import { cameraBetweenDatesListInit } from './camera';

// ----------------------------------------------------------------------

type AlarmDetailState = {
  alarmDetailError: boolean;
  isAlarmDetailLoading: boolean;
  alarmDetail: AlarmDetailFromNotificationMessageModel;
};

const alarmDetailInit: AlarmDetailFromNotificationMessageModel = {
  data: {
    data: {
      alertType: -1,
      cameraId: '',
      image: '',
      moduleId: -1,
      name: '',
      alertDetail: { id: 0, name: '' },
      moduleDetail: { id: 0, name: '', createdAt: '', updatedAt: '' },
      cameraDetail: cameraBetweenDatesListInit
    }
  },
  fcmMessageId: '',
  from: '',
  notification: { body: '', image: '', title: '' },
  priority: ''
};

const initialState: AlarmDetailState = {
  alarmDetailError: false,
  isAlarmDetailLoading: false,
  alarmDetail: alarmDetailInit
};

const slice = createSlice({
  name: 'alarmDetail',
  initialState,
  reducers: {
    // ----------------------------------------------------------------------
    // ALARM DETAIL
    // ----------------------------------------------------------------------

    // START ALARM DETAIL LOADING
    startAlarmDetailLoading(state) {
      state.isAlarmDetailLoading = true;
    },

    // HAS ERROR ALARM DETAIL
    hasErrorAlarmDetail(state, action) {
      state.isAlarmDetailLoading = false;
      state.alarmDetailError = action.payload;
    },

    // EMPLOYEE DETAIL
    getAlarmDetailSuccess(state, action) {
      state.isAlarmDetailLoading = false;
      state.alarmDetail = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const {} = slice.actions;

// ----------------------------------------------------------------------
// ALAMR DETAIL

export function setAlarmDetail(
  alarmDetail: AlarmDetailFromNotificationMessageModel
) {
  return async () => {
    dispatch(slice.actions.startAlarmDetailLoading());
    // dispatch(slice.actions.startDetailLoading());
    try {
      dispatch(slice.actions.getAlarmDetailSuccess(alarmDetail));
    } catch (error: any) {
      dispatch(slice.actions.hasErrorAlarmDetail(error));
    }
  };
}

// ----------------------------------------------------------------------
